import type { SignatureSummaryCounts } from './PdfDocumentEditor.types.ts';

/** The signatures tab header: "2 of 3 placed", plus the date fields when there are any. */
export const formatSignatureSummary = ({
	placedCount,
	slotCount,
	dateCount,
}: SignatureSummaryCounts): string => {
	const placed = `${placedCount} of ${slotCount} placed`;
	if (dateCount === 0) {
		return placed;
	}
	if (dateCount === 1) {
		return `${placed}, 1 date field`;
	}
	return `${placed}, ${dateCount} date fields`;
};
